import React, { useState, useContext } from 'react';
import { InputField, RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import styles from '../TermsConditionsRenderer/style.css';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import { FlowContext } from '../../core/flow-engine';

const RetirementIncomeTaxWitholding = () => {
  const { formProps } = useContext(FlowContext);
  const [showTaxWithholdingInput, setShowTaxWithholdingInput] = useState(true);

  const handleTaxWithholdingOptions = ({ target: { value } }) => {
    if (value === 'NO') return setShowTaxWithholdingInput(false);
    return setShowTaxWithholdingInput(true);
  };
  const onKeyDown = event => {
    if (['.', '-'].includes(event.key)) event.preventDefault();
  };

  const setYear = () => {
    const today = new Date();
    const currentYear = today.getFullYear();

    return currentYear;
  };

  return (
    <div data-name="retirementIncomeWithholding" className="wrapper">
      <SectionHeading text="Federal and State Income Tax Withholding Disclosure" />
      <div>
        <div id="taxWithholdingDisc">
          <p>
            Please read the following Income Tax Withholding Disclosure to
            complete this account update:
          </p>
          <ul>
            <li>
              For nonperiodic payments, the default withholding rate is 10%. You
              can choose to have a different rate between 0% and 100%.
              Generally, you can’t choose less than 10% for payments to be
              delivered outside the United States and its possessions.
            </li>
            <li>
              You may be responsible for payment of estimated tax if you do not
              have enough income tax withheld and you may incur tax penalties if
              your withholding and estimated tax payments are not sufficient.
            </li>
            <li>
              State Income Tax will be withheld from your distribution under the
              applicable state law if your address of record is in a state that
              defaults to withholding.
            </li>
          </ul>
        </div>
      </div>
      <div className="tax-withholding-options-title">
        Retirement Income Fund Tax Withholding
      </div>
      <div className="tax-withholding-option">
        <RadioGroupField
          title="You have the right to elect no federal income tax withholding."
          onChange={handleTaxWithholdingOptions}
          options={[
            {
              title: 'No, don’t withhold for taxes.',
              value: 'NO',
              defaultChecked: false
            },
            {
              title: 'Yes, withhold for taxes.',
              value: 'YES',
              defaultChecked: true
            }
          ]}
          name="taxWithholdingOption"
        />
      </div>

      {showTaxWithholdingInput && (
        <>
          <div className="tax-withholding-options-title">Tax Withholding</div>
          <div className="tax-withholding-input-title">
            Complete this form if you would like a rate of withholding that is
            different from the default withholding rate of 10%. Enter a rate
            between 0-100%
          </div>
          <div className="tax-withholding-input">
            <InputField
              maxLength="3"
              {...formProps.taxWithholdingPercent}
              onKeyDown={onKeyDown}
              defaultValue={10}
              data-e2e="income-withholding-percentage"
            />
          </div>
          <p className="tax-withholding-instructions">
            The following link will take you to the{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.irs.gov/pub/irs-pdf/fw4r.pdf">
              {setYear()} Marginal Rate Tables
            </a>
            . You may use these tables to help you select the appropriate
            withholding rate for this payment or distribution. Instructions on
            how to best use them are included.
          </p>
        </>
      )}
      <div />
      <style jsx>{styles}</style>
    </div>
  );
};

export default RetirementIncomeTaxWitholding;
